module.exports = __webpack_public_path__ + "static/media/horoscope-icon-9.4b2b30c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-9.png
// module id = 1535
// module chunks = 0